import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

const useStyles = makeStyles({
  root: {
    maxWidth: "50%",
  },
});

export default function Notice(props) {
  const [state, setState] = React.useState(props.details);

  const classes = useStyles();

  useEffect(() => {
    setState(props.details);
  }, [props.details]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway" && props.disableClickaway) return;
    setState({ ...state, open: false });
    if (props.onClose) props.onClose();
  };

  function getClassName() {
    if (props.width === "half") {
      return classes.root;
    }
    return null;
  }

  return (
    <Snackbar
      className={getClassName()}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      open={state.open}
      autoHideDuration={props.autoHideDuration ?? 5000}
      onClose={handleClose}
      style={props.style}
    >
      <Alert elevation={5} variant="filled" onClose={handleClose} severity={state.kind}>
        {state.message}
      </Alert>
    </Snackbar>
  );
}
